import type { RibbonControlProps } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import { type MailRibbonControlId, type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import type { RibbonControlId } from 'owa-ribbon-ids';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { logUsage } from 'owa-analytics';
import { debugErrorThatWillShowErrorPopupOnly } from 'owa-trace';
import {
    getSendReceiveAllFoldersControl,
    getWorkOfflineControl,
} from '../../sharedControls/readSharedControlDefinitions';
import { getRibbonMailboxInfo } from 'owa-mail-ribbon-utils/lib/getRibbonMailboxInfo';

export const getSLRSendReceiveTabControlDefinition: (
    controlId: RibbonControlId,
    _tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
) => RibbonControlProps | undefined = owaComputedFn(function getSLRSendReceiveTabControlDefinition(
    controlId: RibbonControlId,
    _tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
): RibbonControlProps | undefined {
    switch (controlId) {
        case 562:
            return getSendReceiveAllFoldersControl(true /* isSLR */, 16, props);
        case 544:
            return getWorkOfflineControl(true /* isSLR */, 16, props);
        default:
            const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);

            debugErrorThatWillShowErrorPopupOnly(
                'getSLRSendReceiveTabControlDefinition UnknownControl: ' + controlId
            );

            logUsage('SLRSendReceiveTabControlDefinitionUnknownControl', mailboxInfo, {
                controlId,
                stack: new Error('SLRSendReceiveTabControlDefinitionUnknownControl').stack,
            });
            return undefined;
    }
});
